import { AnimatePresence } from "framer-motion";
import Toast from "./Toast";

export default function ToastContainer({ toasts, removeToast }) {
 return (
 <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-3 w-full max-w-sm pointer-events-none">
 <AnimatePresence mode="popLayout">
 {toasts.map((toast) => (
 <div key={toast.id} className="pointer-events-auto w-full">
 <Toast toast={toast} removeToast={removeToast} />
 </div>
 ))}
 </AnimatePresence>
 </div>
 );
}
